import { render } from "./NewsList.vue?vue&type=template&id=de90f86a&scoped=true&ts=true"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"

import "./NewsList.vue?vue&type=style&index=0&id=de90f86a&lang=scss&scoped=true"
import "./NewsList.vue?vue&type=style&index=1&id=de90f86a&lang=scss"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de90f86a"]])

export default __exports__